export function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(el => {
        let currentIndex = 0;
        const speed = Number(el.dataset.carousel) ? Number(el.dataset.carousel) : 3000

        setActiveSlide([...el.children], currentIndex);

        setInterval(function () {
            currentIndex = (currentIndex + 1) % el.childElementCount;
            setActiveSlide([...el.children], currentIndex);
        }, speed);
    })
}

function setActiveSlide(items, index) {
    items.forEach(item => {
        item.classList.toggle('is-active', item === items[index])
    })
}
